import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

// Die importierten Interfaces/Datenmodels
import { Address } from '../../interfaces/address';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.css']
})

export class AddressFormComponent implements OnChanges {

  @Input() address: Address = null;

  @Input() addressForm: FormGroup = null;

  @Input() formErrors = [];

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['address']) {
      if (this.address !== null) {
        this.setFormData();
      }
    }
  }

  /**
   * Funktion zum Setzen der Addressdaten im Formular
   */
  private setFormData = () => {
    this.addressForm.patchValue(this.address);
  }

}
